import api from 'sources/api';
import EnvActions from './EnvActions';

const EnvSource = {
  get: {
    remote() {
      return api.get('/front-end-env');
    },
    loading: EnvActions.envLoading,
    success: EnvActions.envSuccess,
    error: EnvActions.envError,
  },
};

export default EnvSource;
